<template>
  <w-sliding-popup ref="slidingPopup" :title="targetTitle" top="50px" width="800px" @close="close">
    <div slot="content" v-loading="isLoading">
      <el-select v-if="managetypeId === 'E2E'" v-model="availSelectedAgent" placeholder="데이터가 없습니다." class="mr-b10" style="width:250px">
        <el-option v-for="agent in agentList" :key="agent.objId" :label="agent.objName" :value="agent.objId" />
      </el-select>
      <el-row class="mr-t5">
        <div class="title-h3 mr-b15">일간</div>
        <w-summary-column-chart-for-avail-rate style="width: 100%; height: 175px;" ref="dayColumnChart"></w-summary-column-chart-for-avail-rate>
      </el-row>
      <el-row class="mr-t5">
        <div class="title-h3 mr-b15">주간</div>
        <w-summary-column-chart-for-avail-rate style="width: 100%; height: 175px;" ref="weekColumnChart"></w-summary-column-chart-for-avail-rate>
      </el-row>
      <el-row class="mr-t5">
        <div class="title-h3 mr-b15">월간</div>
        <w-summary-column-chart-for-avail-rate style="width: 100%; height: 175px;" ref="monthColumnChart"></w-summary-column-chart-for-avail-rate>
      </el-row>
      <el-row class="mr-t5">
        <div class="title-h3 mr-b15">연간</div>
        <w-summary-column-chart-for-avail-rate style="width: 100%; height: 175px;" ref="yearColumnChart"></w-summary-column-chart-for-avail-rate>
      </el-row>
    </div>
  </w-sliding-popup>
</template>

<script>
import { forEach, isNil, isEmpty } from 'lodash';
import SummaryApi from '@/api/performance/summary/summary-info';
import WSummaryColumnChartForAvailRate from './SummaryColumnChartForAvailRate';

export default {
  name: 'WAvailRateSlidingPopup',
  components: {
    WSummaryColumnChartForAvailRate,
  },
  props: {
    objInfo: {
      type: Object,
      default: () => {},
    },
    agentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      params: [],
      dateType: ['day', 'week', 'month', 'year'],
      availSelectedAgent: null,
    };
  },
  computed: {
    targetTitle() {
      return `${this.objInfo.label} 장비 가동률`;
    },
    managetypeId() {
      if (isNil(this.objInfo)) {
        return null;
      }
      return this.objInfo.obj.objManagetypeId;
    },
  },
  watch: {
    availSelectedAgent(to, from) {
      if (!isNil(from)) {
        this.loadData();
      }
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      if (!isEmpty(this.agentList)) {
        this.availSelectedAgent = this.agentList[0].objId;
      }
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      this.isLoading = true;
      const params = {
        managetypeId: this.managetypeId,
        objId: this.objInfo.obj.objId,
      };
      // FMS의 경우 부모 장비 (FACILITY)의 obj_id를 보내도록 한다.
      // FIXME: e2e의 경우는 어떠한 rsc_key (e2e는 여러개)을 보내야할지 협의 후 적용토록 하였음 (보류)
      if (this.managetypeId === 'FMS') {
        params.objId = this.objInfo.obj.parentObjId;
      } else if (this.managetypeId === 'E2E') {
        params.objId = this.availSelectedAgent;
        params.serviceId = this.objInfo.obj.objId;
      }
      // 각 차트 4개 timeType: D, W, M, Y 따로 호출하지않고 Key로 묶어서 한꺼번에 조회토록
      SummaryApi.getAvailableHist(params).then((res) => {
        if (res.data.success) {
          // day, week, month, year Key분리 및 각각 다른 refs로 setData 호출
          forEach(this.dateType, (date) => {
            const target = `${date}ColumnChart`;
            this.$refs[target].setData(res.data.data[date]);
          });
        }
        this.isLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/AvailRateSlidingPopup.vue